export default "__VITE_ASSET__DqXnVABt__"